import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import {
    DataChartsStateRate
} from '../../../interfaces/truckLoadRateServiceInterfaces';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';

export const STATE_RATE_HISTORY_REQUEST = 'STATE_RATE_HISTORY_REQUEST';
export const STATE_RATE_HISTORY_SUCCESS = 'STATE_RATE_HISTORY_SUCCESS';
export const STATE_RATE_HISTORY_FAILURE = 'STATE_RATE_HISTORY_FAILURE';

const requestStateRateHistory = (): object => {
    return {
        type: STATE_RATE_HISTORY_REQUEST
    };
};

const receiveStateRateHistory = (json: DataChartsStateRate): object => {
    return {
        type: STATE_RATE_HISTORY_SUCCESS,
        payload: json
    };
};

const requestStateRateHistoryFailed = (): object => {
    return {
        type: STATE_RATE_HISTORY_FAILURE
    };
};

export const fetchStateRateHistory = (searchQuery: any): Function => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestStateRateHistory());

        try {
            const json: DataChartsStateRate = await ApiService.post(Endpoints.chartsStateRate, searchQuery, true);

            if (Object.keys(json).length > 0) {
                dispatch(receiveStateRateHistory(json));
            } else {
                dispatch(receiveStateRateHistory({} as DataChartsStateRate));
            }
        } catch (err) {
            dispatch(requestStateRateHistoryFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while fetching state rate chart data.',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
